/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/8/28
 * Time: 下午6:29
 */
import title from './title'
// import bold from './bold'
import code from './code'

export const MARKDOWN_MATCH = [
  // bold,
  code,
  title
]



// WEBPACK FOOTER //
// ./src/components/quill/markdown/index.js